




import {defineComponent, onBeforeUnmount, onMounted,  ref} from "@vue/composition-api"
import {ObserverExchangeBus} from "@/shared/composables/ObserverExchangeBus"

export default defineComponent({
    name: "Observer",
    props: {
        options: {
            options: Object,
            required: false
        },
    },
    setup: (props: { options: object }) => {
        const element = ref<HTMLDivElement | null>(null)

        const observer = new IntersectionObserver(([entry]) => {
            if (entry && entry.isIntersecting) {
                ObserverExchangeBus().intersected = true
            }
        }, props.options)

        onMounted(() => {
            if(element.value) {
                observer.observe(element.value)
            }
        })

        onBeforeUnmount(() => {
            observer.disconnect()
        })

        return {
            element
        }
    }
})
